import {HttpHeaders} from '@angular/common/http';
import {Configuration, EmailDto, MessagingServiceInterface, SendEmailResponse, SendSMSResponse, SmsDto} from '@gt-api';
import {Observable, of} from 'rxjs';

export class MessagingServiceStub implements MessagingServiceInterface {
  defaultHeaders: HttpHeaders = new HttpHeaders();
  configuration: Configuration;
  sendEmailWitDto1(organization?: string, login?: string, body?: EmailDto): Observable<SendEmailResponse> {
    return of({code: 200});
  }

  sendSMSWithDto1(organization?: string, login?: string, body?: SmsDto): Observable<SendSMSResponse> {
    return of({code: 200});
  }

  sendSMS(
    body?: string,
    body2?: string,
    body3?: string,
    body4?: string,
    body5?: Array<string>,
    body6?: string,
    extraHttpRequestParams?: any
  ): Observable<SendSMSResponse> {
    return undefined;
  }

  sendEmail(
    body?: string,
    body2?: string,
    body3?: string,
    body4?: string,
    body5?: Array<string>,
    body6?: string,
    body7?: string,
    extraHttpRequestParams?: any
  ): Observable<SendEmailResponse> {
    return of({code: 200});
  }
}
